
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-times",
      function () {
        return require("private-next-pages/travel-times/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-times"])
      });
    }
  